// extracted by mini-css-extract-plugin
export default {"sectionTitle":"SectionHeader_sectionTitle__VXNbM","arrow":"SectionHeader_arrow__mPEj3"};